import {
	isDateLessThanYearInPastExactlyFromChosenDayOrNotInFuture,
	isDateWithOrder,
	isFullySpecifiedDate,
} from 'app/forms/validations/common';
import isBirthNumber from 'app/forms/validations/isBirthNumber';
import isBusinessIn from 'app/forms/validations/isBusinessIn';
import isBusinessName from 'app/forms/validations/isBusinessName';
import isFirstName from 'app/forms/validations/isFirstName';
import isSurname from 'app/forms/validations/isSurname';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const UNLOCKED_CLIENTS_FORM_NAME = 'unlockedClients-filter';

const { firstName, surname, businessName, personIn, birthDate, businessIn } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	surname,
	firstName,
	businessName,
	personIn,
	businessIn,
	birthDate,
	unlockedFrom: 'unlockedFrom',
	unlockedTo: 'unlockedTo',
	extendedFrom: 'extendedFrom',
	extendedTo: 'extendedTo',
	unlockChannels: 'unlockChannels',
};

export default () => ({
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [isSurname()],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.businessName]: {
		deepPath: [FIELDS.businessName],
		validations: [isBusinessName()],
	},
	[FIELDS.personIn]: {
		deepPath: [FIELDS.personIn],
		validations: [isBirthNumber()],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [isBusinessIn()],
	},
	[FIELDS.birthDate]: {
		deepPath: [FIELDS.birthDate],
		validations: [isFullySpecifiedDate()],
	},
	[FIELDS.unlockedFrom]: {
		deepPath: [FIELDS.unlockedFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.unlockedFrom, toFieldName: FIELDS.unlockedTo }),
			isDateLessThanYearInPastExactlyFromChosenDayOrNotInFuture(),
		],
	},
	[FIELDS.unlockedTo]: {
		deepPath: [FIELDS.unlockedTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.unlockedFrom, toFieldName: FIELDS.unlockedTo }),
		],
	},
	[FIELDS.extendedFrom]: {
		deepPath: [FIELDS.extendedFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.extendedFrom, toFieldName: FIELDS.extendedTo }),
			isDateLessThanYearInPastExactlyFromChosenDayOrNotInFuture(),
		],
	},
	[FIELDS.extendedTo]: {
		deepPath: [FIELDS.extendedTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.extendedFrom, toFieldName: FIELDS.extendedTo }),
		],
	},
	[FIELDS.unlockChannels]: {
		deepPath: [FIELDS.unlockChannels],
		validations: [],
	},
});
